import { Flex, Link, Table, Tbody, Td, Text, Tr } from "@chakra-ui/react";
import { useQuery } from "@tanstack/react-query";
import { RiFolderDownloadLine } from "react-icons/ri";
import { FormattedMessage } from "react-intl";

import { ApiBulkExport, getBulkExportFileForDownload } from "@nens/ldo/api-v1";
import { humanFileSize } from "@nens/shared-utils";

interface BulkExportDownloadProps {
  bulkExport: ApiBulkExport;
}

function DownloadButton({ bulkExportId, filename }: { bulkExportId: number; filename: string }) {
  const fileForDownload = useQuery(getBulkExportFileForDownload(bulkExportId, filename));
  return (
    <Link href={fileForDownload.data?.url ?? "#"} textDecoration="underline" download>
      {filename}
    </Link>
  );
}

export function BulkExportDownload({ bulkExport }: BulkExportDownloadProps) {
  return (
    <Flex
      rounded="md"
      w="full"
      border="1px solid #ccc"
      my="40px"
      flexDirection="column"
      justifyItems="flex-start"
    >
      <Flex w="full" borderBottom="1px solid #ccc" alignItems="center">
        <Text fontWeight="bold" p="14px">
          <FormattedMessage id="detailpage.downloads" defaultMessage="Downloads" />
        </Text>
        <Flex
          h="12px"
          justifyContent="center"
          alignItems="center"
          color="bij12_1.700"
          fontWeight="semibold"
          bgColor={"#CC614D20"}
          fontSize={"sm"}
          rounded="full"
          p="14px"
          ml="2px"
        >
          {"1"}
        </Flex>
      </Flex>
      <Flex>
        <Table variant="simple" size="md">
          <Tbody>
            {Object.entries(bulkExport.files).map(([filename, details]) => (
              <Tr>
                <Td w="5%">
                  <RiFolderDownloadLine />
                </Td>
                <Td w="20%" textDecoration="underline">
                  <DownloadButton bulkExportId={bulkExport.id} filename={filename} />
                </Td>
                <Td>{humanFileSize(details.size)}</Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </Flex>
    </Flex>
  );
}
